export default __webpack_public_path__ + "static/media/particles-web-theme9.8907794a.svg";